import React, { useState } from 'react';
import { Snackbar } from '@mui/material';
import SnackbarContext from './SnackbarContext';

const POSITION_STYLES = {
  'top-right': {
    anchorOrigin: { vertical: 'top', horizontal: 'right' },
    style: { mt: 15, mr: 2 }
  },
  'top-left': {
    anchorOrigin: { vertical: 'top', horizontal: 'left' },
    style: { mt: 15, ml: 2 }
  },
  'bottom-right': {
    anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    style: { mb: 2, mr: 2 }
  },
  'bottom-left': {
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    style: { mb: 2, ml: 2 }
  }
};

const SEVERITY_STYLES = {
  success: {
    backgroundColor: 'rgba(46, 125, 50, 0.5)',
    color: 'white'
  },
  error: {
    backgroundColor: 'rgba(211, 47, 47, 0.5)',
    color: 'white'
  },
  warning: {
    backgroundColor: 'rgba(237, 108, 2, 0.5)',
    color: 'white'
  },
  info: {
    backgroundColor: 'rgba(2, 136, 209, 0.5)',
    color: 'white'
  },
  default: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    color: 'black'
  }
};

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'default',
    position: 'top-right'
  });

  const showSnackbar = (message, options = {}) => {
    const { 
      severity = 'default', 
      position = 'top-right',
      duration = 6000 
    } = options;

    setSnackbar({ 
      open: true, 
      message, 
      severity, 
      position,
      duration 
    });
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const positionConfig = POSITION_STYLES[snackbar.position] || POSITION_STYLES['top-right'];
  const severityStyle = SEVERITY_STYLES[snackbar.severity] || SEVERITY_STYLES.default;

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={snackbar.duration}
        onClose={handleClose}
        message={snackbar.message}
        anchorOrigin={positionConfig.anchorOrigin}
        sx={{
          position: 'fixed',
          ...positionConfig.style,
          '& .MuiSnackbarContent-root': {
            ...severityStyle,
            borderRadius: '10px',
            backdropFilter: 'blur(3px)',
            boxShadow: '0 4px 30px rgba(0, 0, 0, 0.2)',
          },
        }}
      />
    </SnackbarContext.Provider>
  );
};